<div class="text-xl font-bold mb-4">{{ mode === 'add' ? 'Add' : 'Edit' }} User</div>

<form [formGroup]="addUserForm" (ngSubmit)="onSubmit()">
  <div class="grid grid-cols-3 gap-5">
    <aux-input label="First Name" formControlName="given_name" validators="required"></aux-input>
    <aux-input label="Last Name" formControlName="family_name" validators="required"></aux-input>
    <fieldset [disabled]="mode === 'edit'">
      <aux-input
        label="Email Address"
        [type]="'email'"
        formControlName="email"
        validators="required|email"
      ></aux-input>
    </fieldset>

    <div>
      <div class="mb-1 text-xs">Company</div>
      <ng-select
        id="vendor"
        class="select select__big"
        formControlName="organization_id"
        bindValue="id"
        bindLabel="name"
        label="Company"
        [clearable]="false"
        [searchable]="false"
        [appendTo]="'body'"
        required
        auxFormError
      >
        <ng-option [value]="vendor" *ngFor="let vendor of vendorsQuery.selectAll() | async">
          <span [title]="vendor.name">{{ vendor.name }}</span>
        </ng-option>
        <ng-option
          *ngIf="isAuxiliusSupport$ | async"
          [value]="{ id: 'Aux Support', name: 'Auxilius Support' }"
        >
          <span [title]="'Auxilius Support'">Auxilius Support</span>
        </ng-option>
      </ng-select>
    </div>

    <div>
      <div class="mb-1 text-xs">Department</div>
      <ng-select
        class="select select__big"
        formControlName="department"
        [items]="departmentOptions"
        [clearable]="false"
        [searchable]="false"
        [appendTo]="'body'"
        bindLabel="label"
        bindValue="key"
        [multiple]="true"
        label="Department"
        auxFormError
        [required]="getFc('organization_id')?.value !== 'Aux Support'"
      >
      </ng-select>
    </div>

    <aux-input
      label="Title"
      formControlName="title"
      [validators]="getFc('organization_id')?.value !== 'Aux Support' ? 'required' : ''"
    ></aux-input>

    <aux-input
      *ngIf="getFc('company')?.value === 'Other'"
      label="Name of other company"
      placeholder="Company"
      formControlName="companyName"
    ></aux-input>

    <div>
      <div class="mb-1 text-xs">User Type</div>
      <ng-select
        class="select select__big"
        formControlName="role"
        [items]="userOptions"
        [clearable]="false"
        [searchable]="false"
        [appendTo]="'body'"
        bindLabel="label"
        label="User Type"
        bindValue="value"
        auxFormError
        required
      >
      </ng-select>
    </div>
  </div>

  <div class="flex space-x-4 mt-4">
    <button class="text-sm font-normal btn btn--blue w-32" type="submit">
      {{ mode === 'add' ? 'Save' : 'Save Edits' }}
    </button>
    <button
      class="text-sm font-normal aux-link focus:outline-none"
      (click)="onCancel()"
      type="button"
    >
      Cancel
    </button>
  </div>
</form>
